import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    marginTop: theme.spacing(24),
});

export const nav: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
});

// `auto` pins the section to the sidebar bottom; the padding keeps a minimum
// gap below the preceding content when the sidebar is full.
export const bottomSection: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(24),
    marginTop: 'auto',
    paddingTop: theme.spacing(24),
});

// Aligns the footer text with the nav items' text (8px gutter + 12px padding).
export const footer: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    marginRight: '-1rem',
    marginLeft: '-1rem',
    paddingLeft: theme.spacing(12),
    color: theme.colors.foregroundsTertiary,
});

export const footerLinks: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(8),
});

export const footerLink: TRuleWithTheme = () => ({
    textDecoration: 'underline',

    ':hover': {
        textDecoration: 'underline',
    },
});
